export default __webpack_public_path__ + "static/media/Group.b5da43c7.png";